import { Component, OnInit } from "@angular/core";
import { IOption } from "ng-select";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { SafetyAlertModalComponent } from "../safety-alert-modal/safety-alert-modal.component";
import { HelperService } from "../services/helper.service";
import { RilrService } from "../services/rilr.service";
import { API_URL } from "../config";
import { ManagementOfChangeService } from "../services/management-of-change.service";

@Component({
  selector: "app-report-rir-print-preview-moc",
  templateUrl: "./report-rir-print-preview-moc.component.html",
  styleUrls: ["./report-rir-print-preview-moc.component.scss"],
  providers: [RilrService, HelperService, ManagementOfChangeService],
})
export class ReportRirPrintPreviewMocComponent implements OnInit {
  public masterData: any = {};

  master: any = {
    initialRiskCategory: {},
    notificationSetSelectedData: [],
  };

  getRiskRegister: any;
  getMocRequireAmend: any;
  dmsMasterData: any;
  actions: any;
  reportEmpName: string;
  reportEmpID: string;
  approvalUsersTbl: any = [];
  approvalUsersTblDump: any = [];
  isSendApprovals: boolean = false;
  reviewerName: any;
  reviewerNameDump: any;

  public reportSystemID: number;
  public documentSystemID: number;
  public documentTypeLabel: string = "incident report";
  public companySystemID = this.helperService.getSelectedCompanyId();
  url: any;

  constructor(
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private rilrService: RilrService,
    private managementOfChangeService: ManagementOfChangeService
  ) {}

  ngOnInit() {
    this.spinner.show();
    setTimeout(() => {
      this.getHeader();
    //   this.getAllApprovals();
    //   this.getAllApprovalsDump();
    }, 0);
    this.url = API_URL + "/";
  }

  public closeModal() {
    this.bsModalRef.hide();
  }


  public notificationSetDisplay: string = '';

  getHeader() {
    const that = this;
    that.managementOfChangeService
      .reportPrintPreviewDataMoc()
      .get({
        reportSystemID: that.reportSystemID,
        documentSystemID: that.documentSystemID,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          //console.log(resp.data.data);
          that.spinner.hide();
          that.master = resp.data.data.reportChangeManagementRequest;
          that.getRiskRegister = resp.data.data.getRiskRegister;
          that.getMocRequireAmend = resp.data.data.getMocRequireAmend;
          that.dmsMasterData = resp.data.data.dmsMasterData;
          that.actions = resp.data.data.actions;

        //   that.approvalUsersTblDump = resp.data.data.getAllApprovalsDump;
        //   that.approvalUsersTbl = resp.data.data.getAllApprovalsRecords;
        //   //console.log(that.approvalUsersTbl);

        //   that.isSendApprovals = that.approvalUsersTbl.length === 0;
        //   that.reviewerNameDump = that.approvalUsersTblDump[0].EmployeeName;
        //   that.reviewerName = that.approvalUsersTbl[0].approve_by.empName;

          if (this.master.notificationSetSelectedData) {
            const parsedData = JSON.parse(this.master.notificationSetSelectedData);
            this.notificationSetDisplay = parsedData.map((item: any) => item.itemName).join(', ');
          }

          


        //   if (typeof that.master.notificationSetSelectedData === "string") {
        //     try {
        //       that.master.notificationSetSelectedData = JSON.parse(
        //         that.master.notificationSetSelectedData
        //       );
        //       //console.log(that.master.notificationSetSelectedData);
        //     } catch (error) {
        //       console.error(
        //         "Failed to parse notificationSetSelectedData:",
        //         error
        //       );
        //       that.master.notificationSetSelectedData = [];
        //     }
        //   }

          if (
            typeof that.master.initialRiskCategory === "object" &&
            that.master.initialRiskCategory !== null
          ) {
            console.log(
              "initialRiskCategory is an object:",
              that.master.initialRiskCategory
            );
          } else if (typeof that.master.initialRiskCategory === "string") {
            try {
              that.master.initialRiskCategory = JSON.parse(
                that.master.initialRiskCategory
              );
              // //console.log(
              //   "Parsed initialRiskCategory:",
              //   that.master.initialRiskCategory
              // );
            } catch (error) {
              console.error("Error parsing JSON:", error);
              that.master.initialRiskCategory = {};
            }
          } else {
            console.warn(
              "Unexpected format for initialRiskCategory:",
              that.master.initialRiskCategory
            );
            that.master.initialRiskCategory = {};
          }


          that.approvalUsersTblDump = resp.data.data.getAllApprovalsDump;
          that.approvalUsersTbl = resp.data.data.getAllApprovalsRecords;
          //console.log(that.approvalUsersTbl);

          that.isSendApprovals = that.approvalUsersTbl.length === 0;
          that.reviewerNameDump = that.approvalUsersTblDump[0].EmployeeName;
          that.reviewerName = that.approvalUsersTbl[0].approve_by.empName;

          

          that.spinner.hide();
          setTimeout(() => {}, 0);
        },
        (error) => {
          that.spinner.hide();
        }
      );
  }

  getAllApprovals() {
    const that = this;
    that.approvalUsersTbl = [];
    that.spinner.show();
    that.rilrService
      .getAllApprovalsRecords()
      .get({
        reportSystemID: that.reportSystemID,
        documentSystemID: that.documentSystemID,
      })
      .subscribe(
        (resp) => {
          that.approvalUsersTbl = resp.data.data;
          //console.log(that.approvalUsersTbl);
          that.isSendApprovals = that.approvalUsersTbl.length === 0;
          //console.log(that.isSendApprovals);

          that.reviewerName = that.approvalUsersTbl[0].approve_by.empName;
          //console.log(that.reviewerName);

          that.spinner.hide();
        },
        (error) => {
          that.spinner.hide();
        }
      );
  }

  getAllApprovalsDump() {
    const that = this;
    that.approvalUsersTblDump = [];
    that.spinner.show();
    that.rilrService
      .getAllApprovalsDump()
      .get({
        reportSystemID: that.reportSystemID,
        documentSystemID: that.documentSystemID,
      })
      .subscribe(
        (resp) => {
          that.approvalUsersTblDump = resp.data.data;
          //console.log(that.approvalUsersTblDump);

          that.reviewerNameDump = that.approvalUsersTblDump[0].EmployeeName;
          that.spinner.hide();
        },
        (error) => {
          that.spinner.hide();
        }
      );
  }

  public print_pdf_preview() {
    const that = this;
    that.rilrService
      .printRIRReportMoc()
      .get({
        reportSystemID: that.reportSystemID,
        documentSystemID: that.documentSystemID,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          const data = resp.data.data;
          window.open(this.url + data.pdf_path, "_blank");
        },
        (error) => {
          if (error.status == 500) {
          }
        }
      );
  }
}


// WEBPACK FOOTER //
// /app/src/app/report-rir-print-preview-moc/report-rir-print-preview-moc.component.ts